/* eslint jsx-a11y/label-has-associated-control: 0 */
import React, { useRef } from 'react'

import AlertGif from '../../../../assets/gif/alert.gif'
import Icon from '../../../../components/icon'
import { If } from '../../../../components/if/if'
import { useOrder } from '../../../../contexts/order'
import {
  Container,
  Overlay,
  Modal,
  CloseButton,
  FormWrapper,
  ConfirmAlert,
} from './styles'

const CustomerQuantityModal = () => {
  const inputRef = useRef<HTMLInputElement>(null)
  const {
    amountCustomerIsOpen, setAmountCustomerIsOpen, amountCustomer, setAmountCustomer,
  } = useOrder()

  function handleSetAmountCustomer() {
    if (!inputRef?.current) return
    setAmountCustomer(Number(inputRef?.current?.value))
    setAmountCustomerIsOpen(false)
  }

  return (
    <Overlay style={{ display: amountCustomerIsOpen ? 'flex' : 'none' }}>
      <Modal>
        <CloseButton type="button" onClick={() => setAmountCustomerIsOpen(false)}>
          <Icon name="close" />
        </CloseButton>
        <Container>
          <If condition={!amountCustomer}>
            <ConfirmAlert>
              <img src={AlertGif} alt="Alerta" />
              <p>
                Antes de fechar a conta confirme a quantidade
                <br />
                de pessoas para fechamento parcial
              </p>

              <button
                type="button"
                onClick={() => setAmountCustomer(1)}
              >
                Confirmar quantidade de pessoas
              </button>
            </ConfirmAlert>
          </If>

          <If condition={amountCustomer}>
            <FormWrapper>
              <label htmlFor="customer-quantity">Digite a quantidade de pessoas</label>
              <input
                name="customer-quantity"
                type="number"
                placeholder="Digite aqui"
                ref={inputRef}
              />
              <button type="submit" onClick={handleSetAmountCustomer}>Confirmar</button>
            </FormWrapper>
          </If>
        </Container>
      </Modal>
    </Overlay>
  )
}
export default CustomerQuantityModal
